"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTransitionEndEventName() {
    var element = document.createElement('_');
    var transitions = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend',
    };
    for (var transition in transitions) {
        if (element.style[transition] !== undefined) {
            return transitions[transition];
        }
    }
    return false;
}
exports.default = getTransitionEndEventName;
